import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import GenderSwitcher from './../../components/GenderSwitcher/GenderSwitcher';
import * as actionTypes from './../../store/actions/genderAction';
import fetchGenderAction from './../../store/actions/fetch/fetchGenderAction';
import Loader from './../../components/Loader/Loader'

/**
 * Gender container
 */
class Gender extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selected, onSelect,
      defaultValues, ready} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-gender-switcher__wrapper'>
        {error && <span className='nppe2-fc-gender-switcher__error'>{error}</span>}
        {!error &&
        <GenderSwitcher data={data} selected={selected} clicked={onSelect}/>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.genderReducer.selected,
    error: state.genderReducer.error,
    data: state.genderReducer.data,
    pending: state.genderReducer.pending,
    ready: state.genderReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchGenderAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Gender);
